<template>
  <v-card>
    <v-card-title>
      <h1 class="headline">
        Создание пользователя Кабинета Клиента
      </h1>
    </v-card-title>
    <v-card-text class="pt-2">
      <v-form v-model="isValid">
        <v-flex
          md8
          sm8
          xs12
        >
          <app-reference
            v-model="client"
            class="mx-2 mb-3"
            label="Клиент*"
            :rules="[rules.required]"
            :return-object="true"
            parent-filter="contactPersonId"
            :parent-id="contactPerson ? contactPerson.id : 0"
            :without-parent-lock="true"
            resource="clients"
            :outline="true"
            :height-field="44"
            @input="isChanged = true"
          />
        </v-flex>
        <v-flex
          md8
          sm8
          xs12
        >
          <app-reference
            v-model="contactPerson"
            class="mx-2 mb-3"
            label="Контактное лицо*"
            :rules="[rules.required]"
            parent-filter="clientId"
            :parent-id="client ? client.id : 0"
            :without-parent-lock="true"
            :return-object="true"
            resource="contact-persons"
            :outline="true"
            :height-field="44"
            @input="changeContactPerson"
          />
        </v-flex>
        <v-flex
          md8
          sm8
          xs12
        >
          <v-text-field
            v-model="name"
            label="E-mail Контактного лица*"
            :rules="[rules.required, rules.email]"
            hide-details
            outline
            height="44"
            class="mx-2 mb-3"
            @input="isChanged = true"
          />
        </v-flex>
        <v-btn
          small
          color="primary"
          :loading="loading"
          :disabled="!(isValid && isChanged)"
          @click="submit"
        >
          Сохранить
        </v-btn>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  getContactPerson,
  addContactPersonEmail,
} from "../../backend/contactPersonsApi.js";
import { createCabinetUser } from "../../backend/cabinetUserApi.js";

export default {
  data() {
    return {
      client: null,
      contactPerson: null,
      name: "",
      isChanged: false,
      isValid: false,
      loading: false,
      rules: {
        required: v => !!v || "Поле обязательно к заполнению",
        email: v => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(v) || v === "" || "Не корректно введен e-mail.";
        },
      },
    };
  },
  methods: {
    async changeContactPerson(value) {
      if (!value) {
        return;
      }
      const result = await getContactPerson("contact-persons", value.id);
      this.name = result.data.Emails.length ? result.data.Emails[0] : "";
      this.isChanged = true;
    },
    async submit() {
      try {
        const user = {
          clientId: this.client.id,
          contactPersonId: this.contactPerson.id,
          name: this.name,
        };
        this.loading = true;
        await createCabinetUser(user);
        await addContactPersonEmail(
          "contact-persons",
          this.contactPerson.id,
          this.name,
        );
        this.client = null;
        this.contactPerson = null;
        this.name = "";
        this.isChanged = false;
        this.showInfo("Пользователь добавлен");
        this.loading = false;
      } catch (error) {
        if (error.message) {
          this.loading = false;
          this.showError(error.message);
        } else {
          this.loading = false;
          throw error;
        }
      }
    },
  },
};
</script>
